function rechargeCustomerCreate(formData) {
  console.log('====== rechargeCustomerCreate ======');
  try {
    // formDataをJSONに変換
    const customer = Object.fromEntries(formData.entries());
    console.log(customer);
    fetch("/apps/booking-app/recharge/customer-create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customer }),
    })
      .then(res => res.json())
      .then(data => console.log(data));
  } catch (error) {
    console.log("=== [Error] rechargeCustomerCreate ===");
    appShowError('Failed to create customer.');
    throw Error('Failed to create customer.');
  }
}